import React from 'react';
import { Grid } from '../../../../../components/layout/grid';
import styles from '../../../../../styles/templates/account-template.module.scss';
import { EditorialCard } from '../../../../../components/editorial-card';
import { Spacer } from '../../../../../components/layout/spacers';

export const Cards = React.memo(({ items }) => (
  <>
    <div className={styles.cards}>
      <Grid fill>
        {items.map(({ body, title, imageUrl, to, displayCondition }) => (
          <EditorialCard
            key={title}
            title={title}
            titleAs='h3'
            imageUrl={imageUrl}
            to={to}
            displayCondition={displayCondition}
          >
            <p>{body}</p>
          </EditorialCard>
        ))}
      </Grid>
    </div>
    <Spacer keyline='bottom' />
  </>
));
